import { render, staticRenderFns } from "./awardCeremony.vue?vue&type=template&id=16cd44ab"
import script from "./awardCeremony.vue?vue&type=script&lang=js"
export * from "./awardCeremony.vue?vue&type=script&lang=js"
import style0 from "./awardCeremony.vue?vue&type=style&index=0&id=16cd44ab&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports